import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, Typography, } from '@mui/material';
import { useIntl } from 'react-intl';
const SelectionItem = ({ id, value, label, type, ...props }) => {
    const intl = useIntl();
    const displayedLabel = intl.formatMessage({
        id: label,
    });
    return (_jsx(FormControlLabel, { ...props, value: value, label: _jsx(Typography, { dangerouslySetInnerHTML: {
                __html: displayedLabel,
            } }, void 0), "data-test": `${type}_group:${id}:option:${value}` }, void 0));
};
export default SelectionItem;
//# sourceMappingURL=SelectionItem.js.map